import { jsPDF } from "jspdf";

const MES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

function fmtKg(n) {
  if (!n || n <= 0) return "—";
  return `${Math.round(n).toLocaleString("es-AR")} kg`;
}
function fmtDistance(m) {
  if (!m || m <= 0) return "—";
  return m >= 1000 ? `${(m / 1000).toFixed(1)} km` : `${Math.round(m)} m`;
}
function fmtDuration(sec) {
  if (!sec || sec <= 0) return "—";
  const h = Math.floor(sec / 3600);
  const mm = Math.floor((sec % 3600) / 60);
  return h > 0 ? `${h}h ${mm}m` : `${mm}m`;
}
function formatMonth(ym) {
  if (!ym || ym.length < 7) return ym || "";
  const [y, m] = ym.split("-");
  const idx = parseInt(m, 10) - 1;
  return idx >= 0 && idx <= 11 ? `${MES[idx]} ${y}` : ym;
}

/**
 * Genera PDF del resumen mensual de entrenamientos.
 */
export async function generateTrainingsSummaryPDF(summary, options = {}) {
  const { yearFilter = "all" } = options;
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const M = 40;
  let y = M;

  const months =
    yearFilter === "all"
      ? summary.by_month || []
      : (summary.by_month || []).filter((m) => m.month.startsWith(yearFilter));

  // ----- Header -----
  doc.setFillColor(10, 10, 10);
  doc.rect(0, 0, pageW, 90, "F");
  doc.setTextColor(255, 59, 48);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("ATHLON SPORTS", M, 40);
  doc.setTextColor(220, 220, 220);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text("Training Control · Resumen de Entrenamientos", M, 58);
  doc.setFontSize(8);
  doc.setTextColor(170, 170, 170);
  doc.text(`Generado: ${new Date().toLocaleString("es-AR")}`, pageW - M, 58, { align: "right" });

  y = 110;
  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("ATLETA", M, y);
  y += 18;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Nombre: ${summary.user?.name || "—"}`, M, y); y += 14;
  doc.text(`Email: ${summary.user?.email || "—"}`, M, y); y += 14;
  doc.text(`Período: ${yearFilter === "all" ? "Histórico completo" : `Año ${yearFilter}`}`, M, y); y += 22;

  // Totales (del período filtrado)
  const t = months.reduce(
    (acc, m) => {
      acc.sessions += m.sessions_count || 0;
      acc.completed += m.completed_count || 0;
      acc.aborted += m.aborted_count || 0;
      acc.volume += m.total_volume_kg || 0;
      acc.distance += m.total_distance_m || 0;
      acc.duration += m.total_duration_sec || 0;
      if (m.avg_rpe != null) {
        acc.rpeSum += m.avg_rpe;
        acc.rpeCount += 1;
      }
      return acc;
    },
    { sessions: 0, completed: 0, aborted: 0, volume: 0, distance: 0, duration: 0, rpeSum: 0, rpeCount: 0 }
  );
  const avgRpe = t.rpeCount ? (t.rpeSum / t.rpeCount).toFixed(1) : "—";

  doc.setFillColor(245, 245, 245);
  doc.rect(M, y, pageW - 2 * M, 78, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(60, 60, 60);
  const cols = ["SESIONES", "COMPLETAS", "VOL FUERZA", "VOL AERÓBICO", "RPE PROM", "TIEMPO"];
  const colW = (pageW - 2 * M) / cols.length;
  cols.forEach((c, i) => doc.text(c, M + 8 + i * colW, y + 18));
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(255, 59, 48);
  const vals = [
    String(t.sessions),
    String(t.completed),
    fmtKg(t.volume),
    fmtDistance(t.distance),
    avgRpe,
    fmtDuration(t.duration),
  ];
  vals.forEach((v, i) => {
    doc.setTextColor(20, 20, 20);
    if (i === 2) doc.setTextColor(255, 59, 48);
    doc.text(v, M + 8 + i * colW, y + 48);
  });
  y += 100;

  // Detalle por mes
  if (months.length === 0) {
    doc.setFont("helvetica", "italic");
    doc.setFontSize(10);
    doc.setTextColor(120, 120, 120);
    doc.text("No hay entrenamientos registrados en el período seleccionado.", M, y);
  } else {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(20, 20, 20);
    doc.text("Detalle por mes", M, y); y += 18;

    const ensureSpace = (h) => {
      if (y + h > pageH - 40) {
        doc.addPage();
        y = M;
      }
    };

    months.forEach((mo) => {
      ensureSpace(60);
      doc.setFillColor(10, 10, 10);
      doc.rect(M, y - 12, pageW - 2 * M, 22, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text(formatMonth(mo.month).toUpperCase(), M + 8, y + 3);
      doc.setTextColor(255, 59, 48);
      const rightSummary = `${mo.sessions_count} sesiones · ${fmtKg(mo.total_volume_kg)}${mo.total_distance_m > 0 ? ` · ${fmtDistance(mo.total_distance_m)}` : ""}`;
      doc.text(rightSummary, pageW - M - 8, y + 3, { align: "right" });
      y += 22;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(40, 40, 40);

      (mo.sessions || []).forEach((s) => {
        ensureSpace(20);
        const date = s.started_at ? s.started_at.slice(0, 10) : "";
        const statusIcon = s.status === "completed" ? "✓" : s.status === "aborted" ? "✗" : "•";
        const left = `${statusIcon}  ${date}  ·  ${s.routine_name || "Sesión libre"}  ·  ${s.sets_count || 0} series${s.duration_sec ? ` · ${fmtDuration(s.duration_sec)}` : ""}`;
        const right = `${fmtKg(s.volume_kg)}${s.distance_m > 0 ? ` · ${fmtDistance(s.distance_m)}` : ""}${s.avg_rpe != null ? ` · RPE ${s.avg_rpe}` : ""}`;
        doc.text(left, M + 8, y + 10);
        doc.text(right, pageW - M - 8, y + 10, { align: "right" });
        y += 16;
      });
      doc.setDrawColor(220, 220, 220);
      doc.line(M, y + 3, pageW - M, y + 3);
      y += 12;
    });
  }

  // Footer
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(120, 120, 120);
    doc.text(
      "Athlon Sports · Training Control · Resumen generado automáticamente",
      pageW / 2, pageH - 18, { align: "center" }
    );
    doc.text(`Página ${i} de ${totalPages}`, pageW - M, pageH - 18, { align: "right" });
  }

  const safeName = (summary.user?.name || "atleta").replace(/[^a-z0-9]+/gi, "_").toLowerCase();
  const periodo = yearFilter === "all" ? "historico" : yearFilter;
  doc.save(`resumen_entrenamientos_${safeName}_${periodo}.pdf`);
}

export default generateTrainingsSummaryPDF;
